// extracted by mini-css-extract-plugin
export var bloc = "twitter-module--bloc--4620e";
export var containerContent = "twitter-module--containerContent--78cca";
export var containerRetweet = "twitter-module--containerRetweet--8c07a";
export var content = "twitter-module--content--73447";
export var contentHashtag = "twitter-module--contentHashtag--4498b";
export var contentId = "twitter-module--contentId--91005";
export var hashtag = "twitter-module--hashtag--019e1";
export var id = "twitter-module--id--80fbe";
export var innerBloc = "twitter-module--innerBloc--bd1e5";
export var itemBloc = "twitter-module--itemBloc--a7dc8";
export var link = "twitter-module--link--64913";
export var logo = "twitter-module--logo--a231c";
export var logoRetweet = "twitter-module--logoRetweet--732e6";
export var nbLines = "twitter-module--nbLines--9da0e";
export var nbLinesTop = "twitter-module--nbLinesTop--15c7f";
export var retweet = "twitter-module--retweet--a477f";
export var screenName = "twitter-module--screenName--77eb7";
export var text = "twitter-module--text--d3db5";